const SCOPE = 'openid profile email';
const clientId = process.env.REACT_APP_XPMGR_GOOGLE_CLIENT_ID;
const domain = window.location.origin || '';
const isExhibitor =
    domain.includes(process.env.REACT_APP_EXHIBITOR_DASHBOARD_DOMAIN) ||
    domain === process.env.REACT_APP_EXHIBITOR_DASHBOARD_DOMAIN;
const redirectURI = isExhibitor
    ? `${process.env.REACT_APP_EXHIBITOR_DASHBOARD_DOMAIN}/login`
    : process.env.REACT_APP_GOOGLE_REDIRECT_URI;

export const GOOGLE_OAUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectURI}&response_type=code&scope=${encodeURIComponent(
    SCOPE
)}&access_type=offline&prompt=consent&include_granted_scopes=true&enable_granular_consent=true`;

export const googleOAuthErrorMessages = {
    access_denied: 'You denied access. Please allow Google to continue.',
    invalid_request: 'The login request was invalid. Please try again.',
    unauthorized_client:
        'This application is not authorized to use Google login.',
    unsupported_response_type: 'The requested login method is not supported.',
    invalid_scope: 'The requested permissions are invalid or not allowed.',
    server_error:
        'Google’s servers encountered an error. Please try again later.',
    temporarily_unavailable:
        'Google login is temporarily unavailable. Please try again in a moment.',

    // Google-specific / token exchange errors
    redirect_uri_mismatch:
        'The login redirect URL does not match the one registered with Google.',
    invalid_client: 'The Google client ID or secret is invalid.',
    invalid_grant:
        'The login session has expired or the code has already been used.',
    interaction_required:
        'You must interact with the login screen to continue.',
    login_required: 'You need to log in to your Google account to proceed.',
    consent_required:
        'You must grant permission to continue with Google login.',
};
